import { render, staticRenderFns } from "./MemberInvitedModal.vue?vue&type=template&id=1b589bf9"
import script from "./MemberInvitedModal.vue?vue&type=script&lang=js"
export * from "./MemberInvitedModal.vue?vue&type=script&lang=js"
import style0 from "./MemberInvitedModal.vue?vue&type=style&index=0&id=1b589bf9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports